module.exports = __webpack_public_path__ + "assets/img/img47.58c42798.png";